var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, Typography } from "@material-ui/core";
import FTLTypography from "./FTLTypography";
export default (_a) => {
    var { label, value, style, backgroundColor = "lightsalmon" } = _a, typographyProps = __rest(_a, ["label", "value", "style", "backgroundColor"]);
    if (process.env.NODE_ENV === "development") {
        return (React.createElement(Box, null,
            label && React.createElement(Typography, { variant: "h5" }, label),
            React.createElement(FTLTypography, Object.assign({ component: "code", style: Object.assign({ backgroundColor, whiteSpace: "pre-wrap" }, style) }, typographyProps), JSON.stringify(value, null, 2))));
    }
    else
        return null;
};
//# sourceMappingURL=FTLJsonLogger.js.map